
export const AppMenus = {
    
	navbarTopRightItems: [],
	navbarTopLeftItems: [],
	navbarSideLeftItems: [
  {
    "path": "/home",
    "label": "Home",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/atend_cac",
    "label": "Atend Cac",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/atend_cac/chamadas",
    "label": "Chamadas",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	AtendCacListHeaderItems: [
  {
    "label": "",
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  }
],
	AtendCacChamadasHeaderItems: [
  {
    "label": "Munícipe",
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": "Destino",
    "align": "left",
    "sortable": false,
    "name": "suborgao",
    "field": "suborgao"
  },
  {
    "label": "Status",
    "align": "left",
    "sortable": false,
    "name": "usuarios_nome",
    "field": "usuarios_nome"
  }
],
	MunicipesListHeaderItems: [
  {
    "label": "Cpf",
    "align": "left",
    "sortable": false,
    "name": "cpf",
    "field": "cpf"
  },
  {
    "label": "Nome",
    "align": "left",
    "sortable": false,
    "name": "nome",
    "field": "nome"
  },
  {
    "label": "Endereco",
    "align": "left",
    "sortable": false,
    "name": "endereco",
    "field": "endereco"
  },
  {
    "label": "Telefone",
    "align": "left",
    "sortable": false,
    "name": "telefone",
    "field": "telefone"
  },
  {
    "label": "Email",
    "align": "left",
    "sortable": false,
    "name": "email",
    "field": "email"
  },
  {
    "label": "Data Nasc",
    "align": "left",
    "sortable": false,
    "name": "data_nasc",
    "field": "data_nasc"
  },
  {
    "label": "Estado Civil",
    "align": "left",
    "sortable": false,
    "name": "estado_civil",
    "field": "estado_civil"
  },
  {
    "label": "Nis",
    "align": "left",
    "sortable": false,
    "name": "nis",
    "field": "nis"
  },
  {
    "label": "Carac Ind",
    "align": "left",
    "sortable": false,
    "name": "carac_ind",
    "field": "carac_ind"
  },
  {
    "label": "Carac Fam",
    "align": "left",
    "sortable": false,
    "name": "carac_fam",
    "field": "carac_fam"
  },
  {
    "label": "Inss",
    "align": "left",
    "sortable": false,
    "name": "inss",
    "field": "inss"
  },
  {
    "label": "Ocupacao",
    "align": "left",
    "sortable": false,
    "name": "ocupacao",
    "field": "ocupacao"
  },
  {
    "label": "Renda",
    "align": "left",
    "sortable": false,
    "name": "renda",
    "field": "renda"
  },
  {
    "label": "Despesas",
    "align": "left",
    "sortable": false,
    "name": "despesas",
    "field": "despesas"
  },
  {
    "label": "Inserido Por",
    "align": "left",
    "sortable": false,
    "name": "inserido_por",
    "field": "inserido_por"
  },
  {
    "label": "Inserido Em",
    "align": "left",
    "sortable": false,
    "name": "inserido_em",
    "field": "inserido_em"
  },
  {
    "label": "Atualizado Em",
    "align": "left",
    "sortable": false,
    "name": "atualizado_em",
    "field": "atualizado_em"
  },
  {
    "label": "Observacoes",
    "align": "left",
    "sortable": false,
    "name": "observacoes",
    "field": "observacoes"
  },
  {
    "label": "Numero",
    "align": "left",
    "sortable": false,
    "name": "numero",
    "field": "numero"
  },
  {
    "label": "Tipo End",
    "align": "left",
    "sortable": false,
    "name": "tipo_end",
    "field": "tipo_end"
  },
  {
    "label": "Rg",
    "align": "left",
    "sortable": false,
    "name": "rg",
    "field": "rg"
  },
  {
    "label": "Endereco Completo",
    "align": "left",
    "sortable": false,
    "name": "endereco_completo",
    "field": "endereco_completo"
  },
  {
    "label": "Atualizado Por",
    "align": "left",
    "sortable": false,
    "name": "atualizado_por",
    "field": "atualizado_por"
  },
  {
    "label": "Idade",
    "align": "left",
    "sortable": false,
    "name": "idade",
    "field": "idade"
  },
  {
    "label": "Apagado Em",
    "align": "left",
    "sortable": false,
    "name": "apagado_em",
    "field": "apagado_em"
  },
  {
    "label": "Apagado",
    "align": "left",
    "sortable": false,
    "name": "apagado",
    "field": "apagado"
  },
  {
    "label": "Pai",
    "align": "left",
    "sortable": false,
    "name": "pai",
    "field": "pai"
  },
  {
    "label": "Mae",
    "align": "left",
    "sortable": false,
    "name": "mae",
    "field": "mae"
  },
  {
    "label": "Deficiencia",
    "align": "left",
    "sortable": false,
    "name": "deficiencia",
    "field": "deficiencia"
  },
  {
    "label": "Religiao",
    "align": "left",
    "sortable": false,
    "name": "religiao",
    "field": "religiao"
  },
  {
    "label": "Alerta Saude",
    "align": "left",
    "sortable": false,
    "name": "alerta_saude",
    "field": "alerta_saude"
  },
  {
    "label": "Id",
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	UsuariosListHeaderItems: [
  {
    "label": "Id",
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": "Login",
    "align": "left",
    "sortable": false,
    "name": "login",
    "field": "login"
  },
  {
    "label": "Senha",
    "align": "left",
    "sortable": false,
    "name": "senha",
    "field": "senha"
  },
  {
    "label": "Email",
    "align": "left",
    "sortable": false,
    "name": "email",
    "field": "email"
  },
  {
    "label": "Foto",
    "align": "left",
    "sortable": false,
    "name": "foto",
    "field": "foto"
  },
  {
    "label": "Nivel",
    "align": "left",
    "sortable": false,
    "name": "nivel",
    "field": "nivel"
  },
  {
    "label": "User Role Id",
    "align": "left",
    "sortable": false,
    "name": "user_role_id",
    "field": "user_role_id"
  },
  {
    "label": "Apagado Em",
    "align": "left",
    "sortable": false,
    "name": "apagado_em",
    "field": "apagado_em"
  },
  {
    "label": "Apagado",
    "align": "left",
    "sortable": false,
    "name": "apagado",
    "field": "apagado"
  },
  {
    "label": "Orgao",
    "align": "left",
    "sortable": false,
    "name": "orgao",
    "field": "orgao"
  },
  {
    "label": "Status",
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": "Nome",
    "align": "left",
    "sortable": false,
    "name": "nome",
    "field": "nome"
  },
  {
    "label": "Suborgao",
    "align": "left",
    "sortable": false,
    "name": "suborgao",
    "field": "suborgao"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],

    exportFormats: {
        print: {
			label: 'Print',
			color: 'blue',
            icon: 'print',
            id: 'print',
            ext: '',
        },
        pdf: {
			label: 'Pdf',
			color: 'red',
            icon: 'picture_as_pdf',
            id: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
			color: 'green',
            icon: 'grid_on',
            id: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
			color: 'teal',
            icon: 'grid_on',
            id: 'csv',
            ext: 'csv',
        },
    },
    
}